import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sales-channels/online-store/')({});
